export default __webpack_public_path__ + "static/media/Instagram.4c0c4f8d.svg";